import React from 'react';
import DashboardPage from '../Pages/DashboardPage';
import { useAppDispatch } from '../Modules/Presentation/hooks';
import useOnce from '../Utils/hook/useOnce';
import { fetchDashboard } from '../Modules/Dashboard/Presentation/actions';
import { message } from 'antd';
import { fetchNotices } from '../Modules/Notice/Presentation/actions';

const DashboardRoutes = () => {
  const dispatch = useAppDispatch();

  useOnce(() => {
    dispatch(fetchDashboard())
      .unwrap().catch(() => {
        message.error('대시보드 정보를 불러오는데 실패하였습니다.')
      }).then(() => {
        dispatch(fetchNotices())
          .unwrap().catch(() => {
            message.error('공지사항 정보를 불러오는데 실패하였습니다.')
          })
      })
  });

  return (
    <DashboardPage />
  );
}
export default DashboardRoutes;
